import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import widgets from './modules/widgets'
import search from './modules/search'
import user from './modules/user'
import token from './modules/token'
import adminUser from './modules/adminUser'
import adminInter from './modules/adminInter'
import adminInsured from './modules/adminInsured'
import claims from './modules/claims'
import underwriting from './modules/underwriting'
import createPersistedState from 'vuex-persistedstate'
import AES from 'crypto-js/aes'
import Enc from 'crypto-js/enc-utf8'
import polTypeParam from './modules/parameters/polTypeParam'
import deptParam from './modules/parameters/deptParam'
import { mavKey } from '@/const'
import branchParam from './modules/branchParam'
import reports from './modules/reports'
import miscParams from './modules/parameters/miscParams'
import accounts from './modules/accounts'
import fundParam from './modules/parameters/fundParam'
import tranDateRangeParam from './modules/parameters/tranDateRangeParam'
import currParam from './modules/currency'
import glAcctParam from './modules/parameters/glAcctParam'
import glAnCode from './modules/parameters/glAnCode'
import company from './modules/parameters/company'
import ctyParam from './modules/parameters/ctyParam'
import paytMethParam from './modules/parameters/paytMethParam'
import tariffParam from './modules/parameters/tariffParam'
import busClsParam from './modules/parameters/busCls'
import uomParam from './modules/parameters/uomParam'
import statsTypeParam from './modules/parameters/statsTypeParam'
import receipt from './modules/receipt'
import reinsurance from './modules/reinsurance'
import pkgParam from './modules/parameters/package'
import creditNote from './modules/creditNote'
import docFormatParam from './modules/parameters/docFormat'
import busSrcParam from './modules/parameters/busSrcParam'
import debitNote from './modules/debitNote'
import commons from './modules/commons'
import payment from './modules/payment'
import bankParam from './modules/parameters/bankParam'
import polStatParam from './modules/parameters/polStatParam'
import acctNoSfxParam from './modules/parameters/acctNoSfxParam'
import gstParam from './modules/parameters/gstParam'
import marineParam from './modules/parameters/marineParam'
import StdRiskTxtParam from './modules/parameters/stdRiskTxtParam/standardRiskText'
import StdItemTxtParam from './modules/parameters/stdRiskTxtParam/standardItemText'
import stdItemTxtDefBenParam from './modules/parameters/stdRiskTxtParam/stdItemTxtDefBen'
import riskAccumulation from './modules/riskAccumulation'
import coverParam from './modules/parameters/coverParam'
import uwMotorParam from './modules/parameters/uwParam/motor/motorParam'
import discLdgParam from './modules/parameters/uwParam/DiscLdg'
import accumTypeParam from './modules/parameters/accumType'
// import match from './modules/match'
import treatyParam from './modules/parameters/treatyParam'
import blkParam from './modules/parameters/blkParam'
import pmtClmResCatPerBusClsParam from './modules/parameters/pmtClmResCatPerBusClsParam'
import pmtNOL1PerBusClsParam from './modules/parameters/pmtNOL1PerBusCls'
import clsResCatParam from './modules/parameters/clmResCatParam'
import clmPaytTypeParam from './modules/parameters/clmPaytTypeParam'
import clmNOL1Param from './modules/parameters/clmNOL/clmNOL1Param'
import clmNOL2Param from './modules/parameters/clmNOL/clmNOL2Param'
import docHdgTxtParam from './modules/parameters/docFormat/docHdgTxt'
import claimStatusParam from './modules/parameters/claimStatusParam'
import coRIPanelParam from './modules/parameters/coRIPanelParam'
import ctyZoneParam from './modules/parameters/ctyParam/ctyZoneParam'
import claimStatusCauseParam from './modules/parameters/claimStatusCauseParam'
import rtnLimParam from './modules/parameters/rtnLimParam'
import interScheme from './modules/interScheme'
import shortTermRateParam from './modules/parameters/shortTermRateParam'
import treatyLimitParam from './modules/parameters/treatyLimitParam'
import journal from './modules/journal'
import pmtBenefitPerBusCls from './modules/parameters/pmtBenefitPerBusCls'
import pmtTariffPerBusClsParam from './modules/parameters/pmtTariffPerBusClsParam'
import tariffBenefitsParam from './modules/parameters/tariffBenefitParam'
import tariffFactorParam from './modules/parameters/tariffFactorParam'
import riskFactorParam from './modules/parameters/riskFactorParam'
import tariffRateParam from './modules/parameters/tariffRateParam'
import tariffPremParam from './modules/parameters/tariffPremParam'
import fireParam from './modules/parameters/fireParam'
import campaignParam from './modules/parameters/campPromoParam/campaignParam'
import acctPeriodParam from './modules/parameters/acctPeriod'
import benefitParam from './modules/parameters/benefitParam'
import marineCargoParam from './modules/parameters/marineCargoParam'
import specFuncAcct from './modules/specFuncAcct'
import clmRel from './modules/claimManagement/specialFuncClm/clmRel'
import xolRecovery from './modules/claimManagement/specialFuncClm/xolRecovery'
import osClmRes from './modules/claimManagement/specialFuncClm/osClmRes'
import unsetClmDocPrtFlag from './modules/claimManagement/specialFuncClm/unsetClmDocPrtFlag'
import mainBusCls from './modules/parameters/mainBusCls'
import industryParam from './modules/parameters/industryParam'
import boIncenSchParam from './modules/parameters/boIncenSchParam'
import custLogTypeParam from './modules/parameters/custLogType'
import riskArea from './modules/parameters/riskArea'
import procNotifParam from './modules/parameters/procNotif'
import stmtType from './modules/parameters/stmtType'
import busAn from './modules/parameters/busAn'
import rtnType from './modules/parameters/rtnType'
import glTran from './modules/parameters/glTran'
import propStatParam from './modules/parameters/propStatParam'
import propPlanParam from './modules/parameters/propPlanParam'
import lnCalc from './modules/parameters/lnCalc'
import calcRate from './modules/parameters/calcRate'
import defStdRiskTxtParam from './modules/parameters/stdRiskTxtParam/defStdRiskTxt'
import proposal from './modules/proposal/'
import nonTrade from './modules/nonTrade'
import normTreatySurplus from './modules/underwriting/normTreatySurplus'
import specFuncTtyAcct from './modules/specFuncTtyAcct'
import clientTypeParam from './modules/parameters/clientTypeParam'
import execInChargeParam from './modules/parameters/execInChargeParam'
import usrClmLimParam from './modules/parameters/usrClmLim'
import commonComments from './modules/comments'
import riskProfParam from './modules/parameters/riskProfParam'
import clmUnrelDel from './modules/claimManagement/specialFuncClm/clmUnrelDel'
import treatyAcct from './modules/treaty'
import eventTypeParam from './modules/parameters/eventTypeParam'
import searchFilter from './modules/searchFilter'
import volCesLimParam from './modules/parameters/volCesLim'
import batchGlUpdate from './modules/batchGlUpdate'
import generalLedger from './modules/generalLedger'
import interTypeParam from './modules/parameters/interTypeParam'
import endtCode from './modules/parameters/endtCode'
import dmncbParam from './modules/parameters/dmncbParam'
import coverLetterParam from './modules/parameters/coverLetterParam'
import matching from './modules/matching'
import durationParam from './modules/parameters/durationParam'
import batchManager from './modules/batchManager'
import glDeptParam from './modules/parameters/glDeptParam'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  // strict: false,
  plugins: [
    createPersistedState({
      key: 'maverick',
      storage: window.sessionStorage,
      // paths: ['claims', 'accounts', 'receipt', 'underwriting', 'payment', 'debitNote', 'creditNote', 'match', 'clmRel', 'nonTrade']
      paths: ['claims', 'accounts', 'receipt', 'underwriting', 'payment', 'debitNote', 'creditNote', 'matching', 'clmRel', 'nonTrade']
    }),
    createPersistedState({
      key: 'token',
      storage: localStorage,
      paths: ['token'],
      setState: (key, state, storage) => {
        // we will make it harder for pen-tester/hacker
        // This is in no way a make safe option as anything on the client side is readable
        storage.setItem('maverick', AES.encrypt(JSON.stringify(state).toString(), mavKey))
      },
      getState: (key, storage) => {
        const value = storage.getItem('maverick')
        try {
          if (value && value !== 'undefined') {
            const bytes = AES.decrypt(value, mavKey)
            const text = bytes.toString(Enc)
            return JSON.parse(text)
          } else {
            return undefined
          }
        } catch (err) {
          return undefined
        }
      }
    })
  ],
  modules: {
    app,
    widgets,
    search,
    user,
    token,
    adminUser,
    claims,
    underwriting,
    adminInter,
    adminInsured,
    deptParam,
    branchParam,
    polTypeParam,
    reports,
    miscParams,
    accounts,
    fundParam,
    tranDateRangeParam,
    currParam,
    glAcctParam,
    glAnCode,
    company,
    ctyParam,
    paytMethParam,
    tariffParam,
    busClsParam,
    uomParam,
    statsTypeParam,
    receipt,
    reinsurance,
    pkgParam,
    creditNote,
    docFormatParam,
    busSrcParam,
    debitNote,
    commons,
    payment,
    bankParam,
    polStatParam,
    acctNoSfxParam,
    gstParam,
    marineParam,
    StdRiskTxtParam,
    StdItemTxtParam,
    stdItemTxtDefBenParam,
    riskAccumulation,
    coverParam,
    uwMotorParam,
    discLdgParam,
    accumTypeParam,
    // match,
    normTreatySurplus,
    treatyParam,
    blkParam,
    pmtClmResCatPerBusClsParam,
    pmtNOL1PerBusClsParam,
    clsResCatParam,
    clmPaytTypeParam,
    clmNOL1Param,
    clmNOL2Param,
    docHdgTxtParam,
    claimStatusParam,
    coRIPanelParam,
    ctyZoneParam,
    claimStatusCauseParam,
    rtnLimParam,
    interScheme,
    shortTermRateParam,
    treatyLimitParam,
    journal,
    pmtBenefitPerBusCls,
    pmtTariffPerBusClsParam,
    tariffBenefitsParam,
    tariffFactorParam,
    riskFactorParam,
    tariffRateParam,
    tariffPremParam,
    fireParam,
    campaignParam,
    acctPeriodParam,
    benefitParam,
    marineCargoParam,
    specFuncAcct,
    clmRel,
    xolRecovery,
    osClmRes,
    unsetClmDocPrtFlag,
    mainBusCls,
    industryParam,
    boIncenSchParam,
    custLogTypeParam,
    riskArea,
    procNotifParam,
    stmtType,
    busAn,
    rtnType,
    glTran,
    propStatParam,
    propPlanParam,
    lnCalc,
    calcRate,
    defStdRiskTxtParam,
    proposal,
    nonTrade,
    specFuncTtyAcct,
    clientTypeParam,
    execInChargeParam,
    usrClmLimParam,
    commonComments,
    riskProfParam,
    clmUnrelDel,
    treatyAcct,
    eventTypeParam,
    searchFilter,
    volCesLimParam,
    batchGlUpdate,
    generalLedger,
    interTypeParam,
    endtCode,
    dmncbParam,
    coverLetterParam,
    matching,
    durationParam,
    batchManager,
    glDeptParam
  }
})
